import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const analyticsOverviewRequest = createAction(
  types.ANALYTICS_OVERVIEW_REQUEST,
);
export const analyticsOverviewSuccess = createAction(
  types.ANALYTICS_OVERVIEW_SUCCESS,
);
export const analyticsOverviewFailure = createAction(
  types.ANALYTICS_OVERVIEW_FAILURE,
);

export const analyticsOnlineRequest = createAction(
  types.ANALYTICS_ONLINE_REQUEST,
);
export const analyticsOnlineSuccess = createAction(
  types.ANALYTICS_ONLINE_SUCCESS,
);
export const analyticsOnlineFailure = createAction(
  types.ANALYTICS_ONLINE_FAILURE,
);

export const analyticsStoreRequest = createAction(
  types.ANALYTICS_STORE_REQUEST,
);
export const analyticsStoreSuccess = createAction(
  types.ANALYTICS_STORE_SUCCESS,
);
export const analyticsStoreFailure = createAction(
  types.ANALYTICS_STORE_FAILURE,
);

export const analyticsStoreDealsRequest = createAction(
  types.ANALYTICS_STORE_DEALS_REQUEST,
);
export const analyticsStoreDealsSuccess = createAction(
  types.ANALYTICS_STORE_DEALS_SUCCESS,
);
export const analyticsStoreDealsFailure = createAction(
  types.ANALYTICS_STORE_DEALS_FAILURE,
);

export const analyticsOnlineDealsRequest = createAction(
  types.ANALYTICS_ONLINE_DEALS_REQUEST,
);
export const analyticsOnlineDealsSuccess = createAction(
  types.ANALYTICS_ONLINE_DEALS_SUCCESS,
);
export const analyticsOnlineDealsFailure = createAction(
  types.ANALYTICS_ONLINE_DEALS_FAILURE,
);

export const analyticsFeatureMetricsRequest = createAction(
  types.ANALYTICS_FEATURE_METRICS_REQUEST,
);
export const analyticsFeatureMetricsSuccess = createAction(
  types.ANALYTICS_FEATURE_METRICS_SUCCESS,
);
export const analyticsFeatureMetricsFailure = createAction(
  types.ANALYTICS_FEATURE_METRICS_FAILURE,
);

export const analyticsVirtualShowroomRequest = createAction(
  types.ANALYTICS_VIRTUAL_SHOWROOM_REQUEST,
);
export const analyticsVirtualShowroomSuccess = createAction(
  types.ANALYTICS_VIRTUAL_SHOWROOM_SUCCESS,
);
export const analyticsVirtualShowroomFailure = createAction(
  types.ANALYTICS_VIRTUAL_SHOWROOM_FAILURE,
);
